export const getFirstParam = (state) => state;
export const getSecondParam = (state, param2) => param2;
export const getThirdParam = (state, param2, param3) => param3;
export const getFourthParam = (state, param2, param3, param4) => param4;
